export enum AdverseActionStatus {
  INITIATED = 'INITIATED',
  PENDING = 'PENDING',
  APPEALED = 'APPEALED',
  SUSTAINED = 'SUSTAINED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
}
